import { useTranslation } from "react-i18next";

import { Forbiddenpage } from "./ForbiddenPage";

export const EntityForbiddenForCampaignPage = () => {
    const { t } = useTranslation();

    return (
        <Forbiddenpage
            description={t(
                "pages.forbidden_for_campaign",
                "This item is not available to the selected company for the selected campaign. It may be available in a past campaign: select one in the campaign selector.",
            )}
        />
    );
};
